import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { unallocatePatientsBulk } from "actions/patient-outreaches";
import ActionModal from "./action-modal";
import SelectedPatientsList from "./selected-patients-list";
import BulkResultsSummary from "./bulk-results-summary";

const BulkUnallocateModal = ({ selectedRows, onClose, onComplete }) => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      const r = await dispatch(
        unallocatePatientsBulk(selectedRows.map(s => s.patientGuid))
      );
      setResult(r);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    if (result && onComplete) onComplete();
    onClose();
  };

  return (
    <ActionModal
      title={`Bulk deallocate (${selectedRows.length})`}
      onClose={handleClose}
    >
      {!result ? (
        <>
          <p>
            Deallocate the following <strong>{selectedRows.length}</strong>{" "}
            patient(s)?
          </p>
          <SelectedPatientsList selectedRows={selectedRows} />
          <p className="patient-outreach-action-modal__hint">
            Patients on an active call are skipped automatically (HTTP 409
            guardrail). The results breakdown will show any blocks.
          </p>
          <div className="patient-outreach-action-modal__footer">
            <button type="button" onClick={handleClose} disabled={submitting}>
              Cancel
            </button>
            <button
              type="button"
              className="patient-outreach-action-modal__primary"
              onClick={handleConfirm}
              disabled={submitting}
            >
              {submitting ? "Deallocating…" : "Deallocate"}
            </button>
          </div>
        </>
      ) : (
        <>
          <BulkResultsSummary result={result} />
          <div className="patient-outreach-action-modal__footer">
            <button
              type="button"
              className="patient-outreach-action-modal__primary"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </>
      )}
    </ActionModal>
  );
};

BulkUnallocateModal.propTypes = {
  selectedRows: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onComplete: PropTypes.func
};

export default BulkUnallocateModal;
